import React, { useCallback, useEffect, useState, useRef } from "react";
import { themes } from "services/constants";
import * as Mui from "@mui/material";
import { showToast } from "services/utils/Status";
import { useSelector } from "react-redux";
import { GlobalDialogBox } from "components/GlobalDialogBox";
import { Info, Edit, RemoveRedEye } from "@mui/icons-material";
import { useForm } from "react-hook-form";
import { leaveGroupHrms } from "services/constants";
import {
  CustomButton,
  InfoMessage,
} from "components/CustomComponents/CustomButton";
import sessionHandling from "services/utils/notificationUtils";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { useDispatch } from "react-redux";
import { tableRowSx } from "services/constants";
import { atleastOneCharacterWithSpace } from "services/constants/patterns";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { tooltipStyleProps } from "services/constants/Styles";

export const LeaveGroupDetails = ({
  setView,
  leaveGroupData,
  leaveTypeData,
  globalSearchValue,
  masterLeaveGroup,
  setLeaveGroupData,
  usersData,
  setFetchLeaveGroupData,
  edit,
  setEdit,
  openDialog,
  setOpenDialog,
  setFetchUsersData,
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [etype, setEtype] = useState("");
  const dispatch = useDispatch();
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const { userScreenAccess } = useSelector((state) => state.tokenReducer);
  const containerRef = useRef(null);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const [tableHeight, setTableHeight] = useState(window.innerHeight * 0.75);

  useEffect(() => {
    const updateHeight = () => {
      setTableHeight(window.innerHeight * 0.75);
    };

    window.addEventListener("resize", updateHeight);

    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  useEffect(() => {
    if (etype !== "") {
      setOpenDialog(true);
    }
  }, [etype, setOpenDialog]);
  useEffect(() => {
    const filteredResults = masterLeaveGroup.filter((item) =>
      leaveGroupHrms.some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase()),
      ),
    );
    setLeaveGroupData(filteredResults);
    setPage(globalSearchValue ? 0 : page);
  }, [globalSearchValue, masterLeaveGroup, page, setLeaveGroupData]);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  }, [page]);

  return (
    <React.Fragment>
      <EtypeDialog
        type={etype}
        setEtype={setEtype}
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        leaveTypeData={leaveTypeData}
        usersData={usersData}
        edit={edit}
        setFetchLeaveGroupData={setFetchLeaveGroupData}
        setFetchUsersData={setFetchUsersData}
      />
      <Mui.Grid
        container
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          alignItems: "flex-end",
          padding: 2,
          paddingRight: 2.5,
        }}
      >
        <CustomButton
          actionFuntion={() => {
            if (
              checkEditorPermission(
                userScreenAccess?.module_details,
                "LMS",
                "Leave Group",
              )
            ) {
              setEtype("Add");
            } else {
              showToast(
                "error",
                "Access denied: You are not authorized to add leave group",
              );
            }
          }}
          actionName="Add Leave Group"
          typeName="button"
        />
      </Mui.Grid>
      <Mui.Grid container>
        <Mui.TableContainer
          ref={containerRef}
          sx={{ mt: 1, width: "100%", ml: 2, mr: 2, maxHeight: tableHeight }}
        >
          <Mui.Table className="border">
            <Mui.TableHead
              sx={{
                backgroundColor: themes.primary,
                position: "sticky",
                top: -1,
                zIndex: 10,
              }}
            >
              <Mui.TableRow sx={tableRowSx}>
                <Mui.TableCell
                  sx={{ color: themes.headLine, fontWeight: "bold" }}
                >
                  Leave Group Name
                </Mui.TableCell>
                <Mui.TableCell
                  sx={{ color: themes.headLine, fontWeight: "bold" }}
                >
                  No of Configuration
                </Mui.TableCell>
                <Mui.TableCell
                  sx={{ color: themes.headLine, fontWeight: "bold" }}
                >
                  Actions
                </Mui.TableCell>
              </Mui.TableRow>
            </Mui.TableHead>
            <Mui.TableBody>
              {leaveGroupData?.length === 0 ? (
                <InfoMessage dataLength={masterLeaveGroup} />
              ) : (
                leaveGroupData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, index) => (
                    <Mui.TableRow
                      key={item?.id}
                      sx={tableRowSx}
                      maxWidth="xl"
                      align="left"
                    >
                      <Mui.TableCell
                        onDoubleClick={() => {
                          setView("ViewLeaveGroup");
                          setEdit(item);
                          dispatch(setGlobalSearchValue(""));
                        }}
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <Mui.Tooltip
                          arrow
                          slotProps={tooltipStyleProps}
                          sx={{
                            textAlign: "left",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {item?.name?.length > 20 ? (
                            <Mui.Tooltip
                              arrow
                              slotProps={tooltipStyleProps}
                              title={item?.name}
                            >
                              <div noWrap sx={{ cursor: "pointer" }}>
                                {item?.name.slice(0, 20)}...
                              </div>
                            </Mui.Tooltip>
                          ) : (
                            item?.name
                          )}
                        </Mui.Tooltip>
                      </Mui.TableCell>
                      <Mui.TableCell sx={{ color: themes.headLine }}>
                        {item?.no_of_configuration ||
                        item?.no_of_configuration === 0
                          ? item?.no_of_configuration
                          : "N/A"}
                      </Mui.TableCell>
                      <Mui.TableCell
                        sx={{ color: themes.headLine, fontWeight: "bold" }}
                      >
                        <Mui.IconButton
                          onClick={() => {
                            if (
                              checkEditorPermission(
                                userScreenAccess?.module_details,
                                "LMS",
                                "Leave Group",
                              )
                            ) {
                              setEtype("Edit");
                              setEdit(item);
                            } else {
                              showToast(
                                "error",
                                "Access denied: You are not authorized to edit leave group",
                              );
                            }
                          }}
                        >
                          <Edit />
                        </Mui.IconButton>
                        <Mui.IconButton
                          onClick={() => {
                            if (
                              checkEditorPermission(
                                userScreenAccess?.module_details,
                                "LMS",
                                "Leave Group",
                              )
                            ) {
                              setView("ViewLeaveGroup");
                              setEdit(item);
                              dispatch(setGlobalSearchValue(""));
                            } else {
                              showToast(
                                "error",
                                "Access denied: You are not authorized to view leave group",
                              );
                            }
                          }}
                        >
                          <RemoveRedEye
                            sx={{
                              cursor: "pointer",
                            }}
                          />
                        </Mui.IconButton>
                      </Mui.TableCell>
                    </Mui.TableRow>
                  ))
              )}
            </Mui.TableBody>
          </Mui.Table>
        </Mui.TableContainer>
      </Mui.Grid>
      <Mui.Grid
        container
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          alignItems: "flex-end",
        }}
      >
        {leaveGroupData?.length > 25 ? (
          <Mui.TablePagination
            className="custom-pagination"
            component="div"
            rowsPerPageOptions={[25, 50, 75, 100]}
            count={leaveGroupData?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        ) : null}
      </Mui.Grid>
    </React.Fragment>
  );
};

export function EtypeDialog({
  type,
  setEtype,
  openDialog,
  setOpenDialog,
  edit,
  setFetchLeaveGroupData,
}) {
  const {
    register,
    reset,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();
  const { domain, token } = useSelector((state) => state.tokenReducer);
  const [buttonLoader, setButtonLoader] = useState(false);
  const handleClose = useCallback(() => {
    setEtype("");
    setValue("name", "");
    reset();

    setOpenDialog(false);
  }, [reset, setEtype, setOpenDialog, setValue]);

  useEffect(() => {
    if (type === "Add") {
      reset();
    } else if (type === "Edit") {
      setValue("name", edit?.name);
    } else if (type === "Delete") {
      setValue("name", "");
      reset();
    }
  }, [edit, reset, setValue, type]);

  const onSubmit = (data) => {
    if (data) {
      if (type === "Add") {
        addLeaveGroup(data?.name);
      } else if (type === "Edit") {
        updateGroupName(data?.name);
      }
    }
  };

  const checkSpecialChar = (e) => {
    if (!/[0-9a-zA-Z ]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const addLeaveGroup = useCallback(
    async (name) => {
      setButtonLoader(true);
      try {
        const response = await fetch(`${domain}leave-group-new/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
          body: JSON.stringify({
            name: name,
          }),
        });
        const res = await response.json();
        if (response.ok) {
          handleClose();
          showToast("success", `${name} added successfully`);
          setValue("uniquename_check", "");
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.user_ids.error);
        }
      } catch (error) {
        showToast("error", error.message);
      } finally {
        setOpenDialog(false);
        setFetchLeaveGroupData(true);
        setButtonLoader(false);
      }
    },
    [
      domain,
      handleClose,
      setFetchLeaveGroupData,
      setOpenDialog,
      setValue,
      token,
    ],
  );

  const updateGroupName = useCallback(
    async (name) => {
      setButtonLoader(true);
      try {
        const response = await fetch(`${domain}leave-group-new/${edit?.id}/`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
          body: JSON.stringify({
            name: name,
          }),
        });
        const res = await response.json();
        if (response.ok) {
          handleClose();
          showToast("success", `${name} updated successfully`);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      } finally {
        setOpenDialog(false);
        setFetchLeaveGroupData(true);
        setButtonLoader(false);
      }
    },
    [
      domain,
      edit?.id,
      handleClose,
      setFetchLeaveGroupData,
      setOpenDialog,
      token,
    ],
  );
  const checkExistingLeaveGroup = useCallback(
    async (name) => {
      try {
        const response = await fetch(
          `${domain}leave-group-namecheck?leave_group=${name}`,
          {
            method: "GET",
            headers: {
              "content-type": "application/json",
              Authorization: `token ${token}`,
            },
          },
        );
        const res = await response.json();
        if (response.ok) {
          if (res?.exists) {
            return "Group name is already exists";
          } else {
            return true;
          }
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    },
    [domain, token],
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <Mui.Grid container></Mui.Grid>
      <GlobalDialogBox
        key={type}
        handleCloseDialog={() => handleClose()}
        open={openDialog}
        title={
          type === "Delete"
            ? "Delete Leave Group"
            : type === "Add"
              ? "Add Leave Group"
              : "Edit Leave Group"
        }
        minWidth={600}
      >
        {type === "" ? null : type === "Delete" ? (
          <>
            <Mui.Grid container>
              <Mui.Grid xs={12}>
                <Mui.Typography sx={{ fontSize: 22, paddingBottom: 2 }}>
                  Are you sure you want to delete{" "}
                  <b style={{ color: themes.redColor }}>{edit?.name}?</b>
                </Mui.Typography>
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid
              container
              sx={{
                paddingTop: 2,
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <CustomButton
                actionFuntion={handleClose}
                actionName="No"
                typeName="submit"
              />
              &nbsp;&nbsp;
              <CustomButton
                actionFuntion={handleSubmit(onSubmit)}
                actionName="Yes"
                disableAction={
                  type === "Delete" && buttonLoader ? buttonLoader : false
                }
                typeName="submit"
              />
            </Mui.Grid>
          </>
        ) : (
          <>
            <Mui.Grid container sx={{ paddingBottom: 1 }}>
              <Mui.Grid xs={4} sx={{ justifyContent: "flex-end" }}>
                <Mui.Stack
                  direction="Row"
                  sx={{
                    paddingTop: 1.5,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "end",
                    alignItems: "flex-end",
                    paddingRight: 1,
                  }}
                >
                  <Mui.Typography style={{ alignSelf: "center" }}>
                    Leave Group Name
                  </Mui.Typography>{" "}
                  &nbsp;&nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    style={{ alignSelf: "center" }}
                    title="This leave group allows grouping specific leave types and users among existing users and leave types"
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Stack>
              </Mui.Grid>
              <Mui.Grid xs={8}>
                <Mui.TextField
                  id="name"
                  placeholder="Enter the leave group name"
                  {...register("name", {
                    required: "Leave group name is required",
                    minLength: {
                      value: 3,
                      message: "Minimum 3 characters are required",
                    },
                    validate: {
                      atleastOneCharacterWithSpaceReg: (value) => {
                        if (
                          atleastOneCharacterWithSpace.test(value) ||
                          value === ""
                        ) {
                          return true;
                        } else {
                          return "Atleast one alphabet required";
                        }
                      },
                      leaveGroup: async (fieldValue) => {
                        if (getValues("uniquename_check") !== fieldValue) {
                          if (fieldValue.trim().length < 3) {
                            return "Minimum 3 characters are required";
                          } else {
                            setValue("uniquename_check", fieldValue);
                            if (type === "Add") {
                              return checkExistingLeaveGroup(fieldValue.trim());
                            } else {
                              if (edit?.name !== fieldValue) {
                                return checkExistingLeaveGroup(
                                  fieldValue.trim(),
                                );
                              }
                            }
                          }
                        } else if (errors.name) {
                          return errors?.name?.message;
                        }
                      },
                    },
                  })}
                  onKeyPress={checkSpecialChar}
                  size="small"
                  InputProps={{
                    inputProps: { maxLength: 100 },
                  }}
                  error={Boolean(errors?.name)}
                  helperText={errors.name?.message || ""}
                  fullWidth
                />
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Stack
              sx={{
                display: "flex",
                paddingTop: 1,
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <CustomButton
                actionFuntion={() => {
                  handleClose();
                }}
                actionName="Cancel"
                typeName="submit"
              />
              &nbsp;&nbsp;
              <CustomButton
                actionFuntion={handleSubmit(onSubmit)}
                actionName={type === "Add" ? "Add" : "Update"}
                typeName="submit"
                disableAction={
                  type === "Add" || type === "Update"
                    ? buttonLoader
                    : buttonLoader
                }
              />
            </Mui.Stack>
          </>
        )}
      </GlobalDialogBox>
    </form>
  );
}
